// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2mME8","image":"Header_image__2cNMB","name":"Header_name__2V9eS","info":"Header_info__T3nrY","infoRow":"Header_infoRow__2G4JK"};